<template>
    <div>
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>

            <div v-if="globalStore.ckperfilsupervisor" class="form-item">
                <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
            </div>

            <div class="form-item">
                <template v-if="!globalStore.showSelectEstabelecimento">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                </template> <template v-else>
                    <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                </template>
            </div>
            
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead>
                <tr>
                    <th>Protocolo</th>
                    <th>Vistoria</th>
                    <th>Registro</th>
                    <th>Estabelecimento</th>
                    <th>Situação</th>
                    <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(pla08, index) in lsDados" :key="pla08.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char20">{{ pla08.xsequencia }}</td>
                    <td class="col-width-char10 center">{{ formatDateFromJson(pla08.dtvistoria) }}</td>
                    <td class="col-width-char10 center">{{ formatDateFromJson(pla08.dtlancamento) }}</td>
                    <td>{{ pla08.nmestabelecimento }}</td>
                    <td class="col-width-char40">{{ pla08.xstatus }}</td>
                    <td class="col-width-char10 center label-link" @click="lerAnexo(pla08.id)">LAUDO</td>
                </tr>
            </tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { formatDateFromJson, validarIntervaloDatas } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const estabelecimentoSelecionado = ref(null);
const idSim = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerAnexo = async(idPla) => {
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const dados = {id: 0, idreferencia: idPla, strparam1: 'L'};
        const req = await genericPost('/lspla/pla08_anexo_base64', dados);
        const pdfBase64 = req.anexo;
        const pdfWindow = window.open("");
        const iframe = pdfWindow.document.createElement("iframe");
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.src = "data:application/pdf;base64," + encodeURIComponent(pdfBase64);
        pdfWindow.document.body.appendChild(iframe);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

const lerDados = async() => {
    try {
        const x = validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        if (x) throw new Error(x);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.ckperfilsupervisor ? idSim.value : globalStore.idsim,
            idestabelecimento: (globalStore.showSelectEstabelecimento) ? estabelecimentoSelecionado.value : globalStore.idestabelecimento,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const req = await genericPost('/lspla/pla08', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>